/*
* Pipeline Theme
*
* Custom Javascript
*/

document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.querySelector('.collection__filters__wrapper');
  if (!drawer) return;

  var originalParent = drawer.parentNode;
  var originalNextSibling = drawer.nextSibling;

  function moveDrawerForMobile() {
    if (window.innerWidth <= 767) {
      if (drawer.parentNode !== document.body) {
        document.body.appendChild(drawer);
      }
    } else {
      if (drawer.parentNode === document.body) {
        if (originalNextSibling && originalNextSibling.parentNode === originalParent) {
          originalParent.insertBefore(drawer, originalNextSibling);
        } else {
          originalParent.appendChild(drawer);
        }
      }
    }
  }

  moveDrawerForMobile();
  window.addEventListener('resize', moveDrawerForMobile);
});

console.log("WHL title sync script loaded");

$(document)
  .off("click.whlTitleSync")
  .on("click.whlTitleSync", ".siblings__link", function () {
    var $swatch = $(this);
    var newProductTitle = $swatch.data("swatch-product-title");
    var $title = $swatch.closest(".product-grid-item").find(".product__grid__title").first();

    console.log("WHL swatch clicked");
    console.log("New title:", newProductTitle);
    console.log("Title found:", $title.length);

    if (newProductTitle && $title.length) {
      $title.text(newProductTitle);
      console.log("Title updated to:", $title.text());
    }
  });


function initWhlSizeGuideInnerTabs() {
  if (document.body.dataset.whlSizeGuideTabsBound === 'true') return;
  document.body.dataset.whlSizeGuideTabsBound = 'true';

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-size-guide-tab-trigger]');
    if (!trigger) return;

    event.preventDefault();

    const holder = trigger.closest('[data-size-guide-tabs]');
    if (!holder) return;

    const target = trigger.getAttribute('data-size-guide-tab-trigger');
    const triggers = holder.querySelectorAll('[data-size-guide-tab-trigger]');
    const panels = holder.querySelectorAll('[data-size-guide-tab-panel]');

    triggers.forEach((btn) => btn.classList.remove('is-active'));
    panels.forEach((panel) => panel.classList.remove('is-active'));

    trigger.classList.add('is-active');

    const activePanel = holder.querySelector('[data-size-guide-tab-panel="' + target + '"]');
    if (activePanel) {
      activePanel.classList.add('is-active');
    }
  });
}

window.addEventListener('DOMContentLoaded', () => {
  initWhlSizeGuideInnerTabs();
});

document.addEventListener('shopify:section:load', () => {
  initWhlSizeGuideInnerTabs();
});

function initWhlSizeGuideInnerTabs() {
  if (document.body.dataset.whlSizeGuideTabsBound === 'true') return;
  document.body.dataset.whlSizeGuideTabsBound = 'true';

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-size-guide-tab-trigger]');
    if (!trigger) return;

    event.preventDefault();

    const holder = trigger.closest('[data-size-guide-tabs]');
    if (!holder) return;

    const target = trigger.getAttribute('data-size-guide-tab-trigger');
    const triggers = holder.querySelectorAll('[data-size-guide-tab-trigger]');
    const panels = holder.querySelectorAll('[data-size-guide-tab-panel]');

    triggers.forEach((btn) => btn.classList.remove('is-active'));
    panels.forEach((panel) => panel.classList.remove('is-active'));

    trigger.classList.add('is-active');

    const activePanel = holder.querySelector('[data-size-guide-tab-panel="' + target + '"]');
    if (activePanel) {
      activePanel.classList.add('is-active');
    }
  });
}


$(document).on('click', '[data-sidebar-filter-form] input, [data-sidebar-filter-form] label, [data-filter-update-url]', function () {
  var $grid = $('[data-products-grid]').first();
  if ($grid.length) {
    $grid.addClass('is-loading');
  }
});

document.addEventListener('click', function (event) {
  var openButton = event.target.closest('[data-popup-modal-open]');
  var closeButton = event.target.closest('[data-popup-modal-close]');

  if (openButton) {
    event.preventDefault();

    var modalId = openButton.getAttribute('aria-controls');
    var modal = document.getElementById(modalId);

    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('popup-modal-open');
  }

  if (closeButton) {
    var modal = closeButton.closest('[data-popup-modal]');
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('popup-modal-open');

    var opener = document.querySelector('[aria-controls="' + modal.id + '"]');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
    }
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  var openModal = document.querySelector('.popup-modal.is-open');
  if (!openModal) return;

  openModal.classList.remove('is-open');
  openModal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('popup-modal-open');

  var opener = document.querySelector('[aria-controls="' + openModal.id + '"]');
  if (opener) {
    opener.setAttribute('aria-expanded', 'false');
  }
});

/* KF | Mobile Product Gallery Changes */

(function () {
  const MOBILE_QUERY = '(max-width: 767px)';

  function initialiseWhlGallery(slideshow) {
    if (!slideshow) return;
    if (slideshow.dataset.whlGalleryReady === 'true') return;

    const wrapper = slideshow.closest(
      '.product__media__wrapper'
    );

    if (!wrapper) return;

    const progressItems = wrapper.querySelectorAll(
      '[data-product-media-progress-item]'
    );

    const slides = Array.from(
      slideshow.querySelectorAll('[data-media-slide]')
    );

    if (!slides.length) return;

    slideshow.dataset.whlGalleryReady = 'true';

    function getSelectedIndex() {
      const selectedSlide = slideshow.querySelector(
        '[data-media-slide].is-selected'
      );

      const selectedIndex = slides.indexOf(selectedSlide);

      return selectedIndex >= 0 ? selectedIndex : 0;
    }

    function updateProgress() {
      const selectedIndex = getSelectedIndex();

      progressItems.forEach(function (item, index) {
        const isActive = index === selectedIndex;

        item.classList.toggle('is-active', isActive);

        item.setAttribute(
          'aria-selected',
          isActive ? 'true' : 'false'
        );
      });
    }

    const galleryObserver = new MutationObserver(function (
      mutations
    ) {
      const selectionChanged = mutations.some(function (
        mutation
      ) {
        return (
          mutation.type === 'attributes' &&
          (
            mutation.attributeName === 'class' ||
            mutation.attributeName === 'aria-hidden'
          )
        );
      });

      if (selectionChanged) {
        updateProgress();
      }
    });

    galleryObserver.observe(slideshow, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-hidden']
    });

    progressItems.forEach(function (item, index) {
      item.addEventListener('click', function () {
        const slide = slides[index];

        if (!slide) return;

        const mediaId = slide.getAttribute('data-media-id');

        if (!mediaId) return;

        slideshow.dispatchEvent(
          new CustomEvent('theme:image:change', {
            detail: {
              id: mediaId
            }
          })
        );
      });
    });

let whlGestureStartX = 0;
let whlGestureStartY = 0;
let whlGestureDirection = null;
let whlGestureActive = false;

slideshow.addEventListener(
  'touchstart',
  function (event) {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;
    if (event.touches.length !== 1) return;

    const zoomedImage = slideshow.querySelector(
      '.mobile-zoom-wrapper.is-inline-zoomed'
    );

    if (zoomedImage) return;

    whlGestureStartX = event.touches[0].clientX;
    whlGestureStartY = event.touches[0].clientY;
    whlGestureDirection = null;
    whlGestureActive = true;
  },
  {
    passive: true,
    capture: true
  }
);

window.addEventListener(
  'touchmove',
  function (event) {
    if (!whlGestureActive) return;
    if (event.touches.length !== 1) return;

    const differenceX =
      event.touches[0].clientX - whlGestureStartX;

    const differenceY =
      event.touches[0].clientY - whlGestureStartY;

    if (
      !whlGestureDirection &&
      Math.max(
        Math.abs(differenceX),
        Math.abs(differenceY)
      ) > 6
    ) {
      whlGestureDirection =
        Math.abs(differenceY) > Math.abs(differenceX)
          ? 'vertical'
          : 'horizontal';
    }

    if (whlGestureDirection === 'vertical') {
      event.stopImmediatePropagation();
    }
  },
  {
    passive: true,
    capture: true
  }
);

function resetWhlGesture() {
  whlGestureActive = false;
  whlGestureDirection = null;
}

window.addEventListener(
  'touchend',
  resetWhlGesture,
  {
    passive: true,
    capture: true
  }
);

window.addEventListener(
  'touchcancel',
  resetWhlGesture,
  {
    passive: true,
    capture: true
  }
);

const zoomTargets = wrapper.querySelectorAll(
  '.mobile-zoom-wrapper'
);

zoomTargets.forEach(function (target) {
  if (target.dataset.whlInlineZoomReady === 'true') {
    return;
  }

  const image = target.querySelector('img');
  const mediaSlide = target.closest('[data-media-slide]');

  if (!image || !mediaSlide) return;

  target.dataset.whlInlineZoomReady = 'true';

  let scale = 1;
  let startScale = 1;
  let startDistance = 0;
  let translateX = 0;
  let translateY = 0;
  let panStartX = 0;
  let panStartY = 0;
  let panOriginX = 0;
  let panOriginY = 0;

  image.style.transformOrigin = 'center center';
  image.style.willChange = 'transform';

  function getDistance(touches) {
    const x = touches[0].clientX - touches[1].clientX;
    const y = touches[0].clientY - touches[1].clientY;

    return Math.sqrt((x * x) + (y * y));
  }

  function clamp(value, minimum, maximum) {
    return Math.min(Math.max(value, minimum), maximum);
  }

  function constrainTranslation() {
    const maximumX =
      (target.clientWidth * (scale - 1)) / 2;

    const maximumY =
      (target.clientHeight * (scale - 1)) / 2;

    translateX = clamp(
      translateX,
      -maximumX,
      maximumX
    );

    translateY = clamp(
      translateY,
      -maximumY,
      maximumY
    );
  }

  function applyTransform(animate) {
    image.style.transition = animate
      ? 'transform 200ms ease'
      : 'none';

    image.style.transform =
      'translate3d(' +
      translateX +
      'px, ' +
      translateY +
      'px, 0) scale(' +
      scale +
      ')';
  }

  function resetZoom(animate) {
    scale = 1;
    startScale = 1;
    translateX = 0;
    translateY = 0;

    applyTransform(animate);
    target.classList.remove('is-inline-zoomed');
  }

  target.addEventListener(
    'touchstart',
    function (event) {
      if (!window.matchMedia(MOBILE_QUERY).matches) {
        return;
      }

      if (event.touches.length === 2) {
        event.preventDefault();
        event.stopImmediatePropagation();

        startDistance = getDistance(event.touches);
        startScale = scale;

        target.classList.add('is-inline-zoomed');
        return;
      }

      if (event.touches.length === 1 && scale > 1) {
        event.preventDefault();
        event.stopImmediatePropagation();

        panStartX = event.touches[0].clientX;
        panStartY = event.touches[0].clientY;
        panOriginX = translateX;
        panOriginY = translateY;
      }
    },
    {
      passive: false,
      capture: true
    }
  );

  target.addEventListener(
    'touchmove',
    function (event) {
      if (!window.matchMedia(MOBILE_QUERY).matches) {
        return;
      }

      if (event.touches.length === 2) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const currentDistance = getDistance(event.touches);

        scale = clamp(
          startScale * (currentDistance / startDistance),
          1,
          3
        );

        constrainTranslation();
        applyTransform(false);
        return;
      }

      if (event.touches.length === 1 && scale > 1) {
        event.preventDefault();
        event.stopImmediatePropagation();

        translateX =
          panOriginX +
          (event.touches[0].clientX - panStartX);

        translateY =
          panOriginY +
          (event.touches[0].clientY - panStartY);

        constrainTranslation();
        applyTransform(false);
      }
    },
    {
      passive: false,
      capture: true
    }
  );

  target.addEventListener(
    'touchend',
    function (event) {
      if (!window.matchMedia(MOBILE_QUERY).matches) {
        return;
      }

      if (scale <= 1.02) {
        resetZoom(true);
        return;
      }

      if (event.touches.length === 1) {
        panStartX = event.touches[0].clientX;
        panStartY = event.touches[0].clientY;
        panOriginX = translateX;
        panOriginY = translateY;
      }
    },
    {
      passive: false,
      capture: true
    }
  );

  target.addEventListener(
    'click',
    function (event) {
      if (!window.matchMedia(MOBILE_QUERY).matches) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  const slideObserver = new MutationObserver(function () {
    if (!mediaSlide.classList.contains('is-selected')) {
      resetZoom(false);
    }
  });

  slideObserver.observe(mediaSlide, {
    attributes: true,
    attributeFilter: ['class']
  });
});

    updateProgress();
  }

  function findWhlGalleries() {
    document
      .querySelectorAll('[data-product-slideshow]')
      .forEach(function (slideshow) {
        initialiseWhlGallery(slideshow);
      });
  }

  document.addEventListener(
    'DOMContentLoaded',
    findWhlGalleries
  );

  document.addEventListener(
    'shopify:section:load',
    findWhlGalleries
  );

  window.setTimeout(findWhlGalleries, 500);
})();

if (document.body.classList.contains('template-product')) {
  document.documentElement.classList.add(
    'whl-product-scroll-container'
  );
}